// =============================================================================
// header.js | Author: Nexwork
// =============================================================================

$(document).ready(function () {

    'use strict';

    $('.big-hero').not('.slick-initialized').slick({
        slidesToShow: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        fade: true,
    });

    if ($('.stichtinglvo-slider')) {
        $('.big-hero').not('.slick-initialized').slick({
            slidesToShow: 1,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            infinite: true,
            fade: true,
            asNavFor: '.stichtinglvo-slider'
        });
        $('.stichtinglvo-slider').not('.slick-initialized').slick({
            slidesToShow: 1,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            infinite: true,
            fade: true,
            asNavFor: '.big-hero'
        });
    }
});
